export const DASHBOARD_MENU_PORTAL_DIV_ID = 'dashboard-menu-wrapper';
